
export default "/assets/reddit.67ced62d.svg"